export const GAP = {
	xxs: 'gap-xxs',
	xs: 'gap-xs',
	sm: 'gap-sm',
	md: 'gap-md',
	lg: 'gap-lg', // --design-spacing-lg 1.5rem (24px)
	xl: 'gap-xl', // (32px)
	xxl: 'gap-xxl',
	xxxl: 'gap-xxxl',
} as const;

export type Gap = keyof typeof GAP;


export const GAP_TABLET = {
	xxs: 'tablet:gap-xxs',
	xs: 'tablet:gap-xs',
	sm: 'tablet:gap-sm',
	md: 'tablet:gap-md',
	lg: 'tablet:gap-lg',
	xl: 'tablet:gap-xl',
	xxl: 'tablet:gap-xxl',
	xxxl: 'tablet:gap-xxxl',
} as const;

export type GapTablet = keyof typeof GAP_TABLET;


export const GAP_DESKTOP = {
	xxs: 'desktop:gap-xxs',
	xs: 'desktop:gap-xs',
	sm: 'desktop:gap-sm',
	md: 'desktop:gap-md',
	lg: 'desktop:gap-lg',
	xl: 'desktop:gap-xl',
	xxl: 'desktop:gap-xxl',
	xxxl: 'desktop:gap-xxxl',
} as const;

export type GapDesktop = keyof typeof GAP_DESKTOP;
